import React from "react";
import { Route } from "react-router-dom";
import { artemulkImages } from "../../data/artemulkContent";
import BranchesSection from "../about/BranchesSection";
import StaffSection from "../about/StaffSection";
import Back from "../common/Back";
import Call1 from "../Call1/Call1";
import Whatsapp1 from "../Whatsapp1/Whatsapp1";
import "../about/about.css";

const coverImg = artemulkImages.pageCover;

const Branches = () => {
  const ScrollToTop = () => {
    window.scrollTo(0, 0);
    return null;
  };

  return (
    <>
      <Route component={ScrollToTop} />
      <section className="branches-page min-h-screen">
        <Back name="Arte Mülk" title="Şubelerimiz & Ekibimiz" cover={coverImg} />
        <div className="pt-12 px-[3%] md:px-[6%]">
          <BranchesSection />
          <StaffSection />
        </div>
        <Call1 />
        <Whatsapp1 />
      </section>
    </>
  );
};

export default Branches;
